import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Api from "../../config/Api";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../../Reducers/Authentication";
import Logo from "../../assets/images/logo.png";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const Index = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const isAdmin = useSelector((state) => state.authentication.isAdmin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isAdmin === true) {
      navigate("/dashboard");
    }
  }, [isAdmin, navigate]);

  //Login Submit Function
  const onSubmit = async (data) => {
    setIsLoading(true);
    const body = {
      email: data.email,
      password: data.password,
    };
    // console.log(body);
    const res = await Api("user-login", "POST", body);
    // console.log(res);

    if (res.data.status === 1) {
      dispatch(setAuth(res.data.UserDetails));
      navigate("/dashboard");
      toast.success("Login Successful", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsLoading(false);
    } else {
      toast.error(res?.data?.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="loginsplit">
        <div className="loginhero">
          <div className="loginmotto">Be aware. Be prepared.</div>
          <h1>NSDMIS Master Portal</h1>
          <p>Nagaland State Disaster Management Authority</p>
        </div>
        <div className="loginpanel">
          <div className="loginform">
            <Link to="/">
              <img src={Logo} alt="NSDMA logo" className="loginlogo" />
            </Link>
            <h2>Login</h2>
            <p className="loginsub">Sign in to continue to the portal.</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              <div className="col-lg-12">
                <div className="input-box">
                  <label className="form-label">Username</label>
                  <input
                    type="text"
                    placeholder="Username"
                    disabled={isLoading}
                    {...register("email", {
                      required: "Username is required",
                    })}
                  />
                  {errors.email && (
                    <div className="error_line">
                      {errors.email.message}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="input-box">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    placeholder="Password"
                    disabled={isLoading}
                    {...register("password", {
                      required: "Password is required",
                    })}
                  />
                  {errors.password && (
                    <div className="error_line">
                      {errors.password.message}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Login"}
                  </button>
                </div>
              </div>
            </div>
          </form>

            <p className="loginfooter">
              Copyright © NSDMA Admin. All Rights Reserved{" "}
              {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
